import { ProductVariant } from '@medusajs/medusa'

export const canBuy = (variant: Omit<ProductVariant, 'beforeInsert'>) => {
    return variant.inventory_quantity > 0 // || variant.allow_backorder === true NOTE: we use backorder to allow it to remain in the subscription / cart editing, but it should not allow an add to cart
}
